import { Swiper, SwiperSlide } from 'swiper/react';
import { useDispatch } from 'react-redux';
import { setactiveItem } from 'store/cards';
import useActiveItem from 'hooks/useActiveItem';
import { useSlider } from 'components/SliderContext';
import { usePopup } from 'hooks/usePopup';
import { useSoundPath } from 'hooks/useSoundPath';
import { useLocation } from 'react-router-dom';

const CardsCollectionSlider = ({ list }) => {

  const {search} = useLocation();
  const { swiperRef } = useSlider();
  const {activeItem} = useActiveItem();
  const dispatch = useDispatch();
  const setPopupHook = usePopup();
  const playSound = useSoundPath();

  const scrollToSearchedItem = (id) => {
    const searchParams = new URLSearchParams(search);
    const searchedId = searchParams.get('search_id');
    const scrollCondition = id === Number(searchedId);
    if (scrollCondition) {
      const element = document.getElementById(`item-${id}`);
      if (element) {
        element.scrollIntoView({block: 'center' });
      }
    }
  }

  const itemSetActiveHandler = (item) => {
    dispatch(setactiveItem(item));
    playSound('main');
  }

  const openPurchaseWindow = () => setPopupHook({type: 'purchase'});

  const getImage = (img) => {
    if (!img || img === '') {
      return 'https://placehold.co/147x247'
    } else return img
  }

  return (
    <Swiper
      ref={swiperRef}
      className="cards-list__block cards-list__block--slider"
      slidesPerView='auto'
      spaceBetween={4}
      onAfterInit={(swiper) => {swiper.update()}}
    >
      {
        list.map((item) => {
          scrollToSearchedItem(item.id)
          return (
            <SwiperSlide
              id={`item-${item.id}`}
              key={item.id}
              className={`cards-list__block-item cards-list__block-item--slide ${activeItem === item ? 'active' : ''}`}
              onClick={() => itemSetActiveHandler(item)}
            >
              <img src={getImage(item.image) || 'https://placehold.co/147x247'}className="cards-list__block-item-pic" alt="" />
              <b className="cards-list__block-item-text">${item.cost}</b>
              <p className="cards-list__block-item-rarity">{item.name}</p>
              <span
                className={
                  `cards-list__block-item-tag cards-list__block-item-tag--${item.tag === 'identity pack' ? 'identity' : 'prediction'}`
                }
              >
                {item.tag}
                </span>
              <button className="cards-list__block-item-button" onClick={openPurchaseWindow}>Buy now</button>
            </SwiperSlide>
          )
        })
      }
    </Swiper>
  )
}

export default CardsCollectionSlider;
